module.exports = __webpack_public_path__ + "img/image1.2.13c0e488.png";